// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logout{text-align:center}.logout .form-container{border-radius:10px;margin-bottom:20px;padding:20px;width:100%}.logout label{color:#fff}.logout .goodbye{font-size:24px;margin-top:20px}.logout .stars{font-size:30px}.logout .stars .react-rater-star.is-active,.logout .stars .react-rater-star.will-be-active{color:gold}", ""]);
// Exports
module.exports = exports;
